import React from 'react';
import { Link } from 'react-router-dom';
import './StorefrontGuestOrLoginBanner.css';

export default function StorefrontGuestOrLoginBanner({ companyUrl, onContinueGuest, layout = 'inline' }) {
  const loginHref = `/book/${companyUrl}/login`;
  const rootClass =
    layout === 'gate'
      ? 'storefront-guest-login-banner storefront-guest-login-banner--gate'
      : 'storefront-guest-login-banner';

  return (
    <div className={rootClass}>
      <div className="container">
        <div className="storefront-guest-login-banner__card">
          <div className="storefront-guest-login-banner__inner">
            <div className="storefront-guest-login-banner__actions">
              <button
                type="button"
                className="storefront-guest-login-banner__btn storefront-guest-login-banner__btn--secondary"
                onClick={onContinueGuest}
              >
                Continue as guest
              </button>
              <Link
                to={loginHref}
                className="storefront-guest-login-banner__btn storefront-guest-login-banner__btn--primary"
              >
                Log in to book
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
